import { Component, inject } from '@angular/core';
import { ExperimentCreateService } from '@services/experiment-create/experiment-create.service';

@Component({
  selector: 'app-experiment-create',
  templateUrl: './experiment-create.component.html',
  styleUrl: './experiment-create.component.css'
})
export class ExperimentCreateComponent {
  public stageLevel = 1;

  private stages = inject(ExperimentCreateService).getStages();
  private currentStage = 'details';

  get experimentCreateStage() {
    return this.stages[this.currentStage];
  }

  displayNextStage() {
    if (this.stageLevel === 1) {
      this.stageLevel = 2;
      this.currentStage = 'import-dataset';
    }
  }

  displayPreviousStage() {
    if (this.stageLevel === 2) {
      this.stageLevel = 1;
      this.currentStage = 'details';
    }
  }

}
